module.exports = __webpack_public_path__ + "static/img/packaging_1.cda8814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/articles/packaging_1.jpg
// module id = VOuU
// module chunks = 1